/* Packrift delivered-cost worksheet. Buyer inputs only; no network or storage. */
(function (root) {
  'use strict';
  const moneyFields = ['merchandise', 'shipping', 'fees'];
  function amount(value, label, errors, key) {
    const text = String(value == null ? '' : value).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(text) || Number(text) > 10000000) {
      errors.push({key, message: label + ': enter a dollar amount from 0 to 10,000,000 with no more than two decimal places. Enter 0 when none applies.'});
      return 0;
    }
    return Math.round(Number(text) * 100);
  }
  function count(value, label, errors, key) {
    const text = String(value == null ? '' : value).trim();
    if (!/^\d+$/.test(text) || Number(text) < 1 || Number(text) > 1000000) {
      errors.push({key, message: label + ': enter a whole number from 1 to 1,000,000.'});
      return 0;
    }
    return Number(text);
  }
  function compare(input) {
    const errors = [];
    input = input || {};
    const sides = ['current', 'candidate'].map(side => {
      const raw = input[side] || {}, label = side === 'current' ? 'Current supplier' : 'Candidate supplier';
      const cents = moneyFields.map(key => amount(raw[key], label + ' ' + key, errors, side + '-' + key));
      const units = count(raw.units, label + ' physical units', errors, side + '-units');
      const tax = input.taxMode === 'include' ? amount(raw.tax, label + ' tax', errors, side + '-tax') : 0;
      return {units, totalCents: cents.reduce((a, b) => a + b, 0) + tax};
    });
    const orders = count(input.orders, 'Orders per year', errors, 'orders');
    if (!['exclude', 'include'].includes(input.taxMode)) errors.push({key:'taxMode', message:'Choose whether both totals exclude tax or include the actual tax charged.'});
    if (!/^\d{5}$/.test(String(input.zip || '').trim())) errors.push({key:'zip', message:'Enter the same five-digit delivery ZIP used for both quotes.'});
    const date = String(input.date || '');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(Date.parse(date)) || new Date(date).toISOString().slice(0,10) !== date) errors.push({key:'date', message:'Enter a valid comparison date.'});
    for (const [key, message] of [['specs','Confirm dimensions, material, grade and required performance match.'], ['delivery','Confirm the delivery address type, service and receiving requirements match.'], ['validity','Confirm both prices are valid for the comparison date and required arrival date.']]) {
      if (input[key] !== true) errors.push({key, message});
    }
    if (sides[0].units && sides[1].units && sides[0].units !== sides[1].units) errors.push({key:'candidate-units',message:'The physical unit counts differ. Requote both suppliers for the same quantity before comparing order or annual totals.'});
    if (errors.length) return {ok:false, errors};
    const [current, candidate] = sides;
    for (const side of sides) {
      side.perUnit = side.totalCents / 100 / side.units;
      side.perOrder = side.totalCents / 100;
      side.annual = side.totalCents * orders / 100;
    }
    const difference = (current.totalCents - candidate.totalCents) / 100;
    return {ok:true, current, candidate, orders, difference, annualDifference:difference * orders, taxMode:input.taxMode};
  }
  const usd = (value, unit) => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:unit ? 4 : 2,maximumFractionDigits:unit ? 8 : 2}).format(value);
  function init(doc) {
    doc.querySelectorAll('[data-pxu-delivered]').forEach(panel => {
      if (panel.dataset.pxuReady) return;
      panel.dataset.pxuReady = 'true';
      const get = key => panel.querySelector('[data-cost="' + key + '"]');
      const result = panel.querySelector('[data-cost-result]');
      const errorsBox = panel.querySelector('[data-cost-errors]');
      const summary = panel.querySelector('[data-cost-summary]');
      let lastSummary = '';
      const read = () => {
        const input = {};
        ['orders','taxMode','zip','date'].forEach(key => input[key] = get(key).value);
        ['specs','delivery','validity'].forEach(key => input[key] = get(key).checked);
        ['current','candidate'].forEach(side => {
          input[side] = {};
          ['merchandise','shipping','fees','units','tax'].forEach(key => input[side][key] = get(side + '-' + key).value);
        });
        return input;
      };
      const invalidate = () => {
        result.hidden = true; summary.hidden = true; lastSummary = '';
        panel.querySelector('[data-cost-copy]').textContent = 'Copy comparison';
        const include = get('taxMode').value === 'include';
        ['current','candidate'].forEach(side => {get(side + '-tax').disabled = !include; get(side + '-tax').closest('label').hidden = !include;});
      };
      panel.addEventListener('input', invalidate);
      panel.addEventListener('change', invalidate);
      panel.querySelector('[data-cost-calculate]').addEventListener('click', () => {
        const input = read(), data = compare(input);
        panel.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
        errorsBox.replaceChildren();
        if (!data.ok) {
          invalidate();
          const title = doc.createElement('strong'); title.textContent = 'Complete the comparison first'; errorsBox.append(title);
          const list = doc.createElement('ul');
          data.errors.forEach(error => { const li = doc.createElement('li'); li.textContent = error.message; list.append(li); const field = get(error.key); if (field) field.setAttribute('aria-invalid','true'); });
          errorsBox.append(list); errorsBox.hidden = false;
          const field = get(data.errors[0].key); if (field) field.focus();
          return;
        }
        errorsBox.hidden = true;
        result.querySelector('[data-cost-verdict]').textContent = data.difference === 0 ? 'The entered delivered totals are equal.' : 'The candidate is ' + usd(Math.abs(data.difference)) + (data.difference > 0 ? ' lower' : ' higher') + ' per order.';
        for (const side of ['current','candidate']) for (const metric of ['perUnit','perOrder','annual']) result.querySelector('[data-result="'+side+'-'+metric+'"]').textContent = usd(data[side][metric],metric === 'perUnit');
        result.querySelector('[data-cost-basis]').textContent = 'Buyer-input estimate • ' + data.current.units.toLocaleString('en-US') + ' physical units per order • ' + data.orders.toLocaleString('en-US') + ' identical orders per year • ' + (data.taxMode === 'include' ? 'Includes the tax amounts entered.' : 'Excludes sales tax on both sides.');
        result.querySelector('[data-cost-annual]').textContent = data.difference === 0 ? 'No annual cost difference at this order frequency.' : 'At this frequency, the candidate is ' + usd(Math.abs(data.annualDifference)) + (data.difference > 0 ? ' lower' : ' higher') + ' per year, if quantities and all entered costs stay the same.';
        lastSummary = ['Packaging delivered-cost comparison — buyer-input estimate','Compared: '+input.date+' | Delivery ZIP: '+input.zip,'Quantity: '+data.current.units+' physical units per order | '+data.orders+' identical orders/year','Tax: '+(data.taxMode === 'include' ? 'actual entered amounts included' : 'excluded on both sides'),'Current: '+usd(data.current.perOrder)+'/order | '+usd(data.current.perUnit,true)+'/unit | '+usd(data.current.annual)+'/year','Candidate: '+usd(data.candidate.perOrder)+'/order | '+usd(data.candidate.perUnit,true)+'/unit | '+usd(data.candidate.annual)+'/year','Buyer confirmed matching specs, receiving requirements and quote validity. Product suitability and future costs require review.'].join('\n');
        summary.value = lastSummary; result.hidden = false; result.focus();
      });
      panel.querySelector('[data-cost-copy]').addEventListener('click', async event => {
        if (!lastSummary) return;
        const button = event.currentTarget;
        summary.hidden = false;
        try {await root.navigator.clipboard.writeText(lastSummary);button.textContent='Copied';}
        catch (_) {summary.focus(); summary.select(); button.textContent='Select and copy the text below';}
      });
      panel.querySelector('[data-cost-reset]').addEventListener('click', () => {
        panel.querySelectorAll('[data-cost]').forEach(el => {if (el.type === 'checkbox') el.checked=false; else el.value=''; el.removeAttribute('aria-invalid');});
        errorsBox.hidden=true; invalidate(); get('current-merchandise').focus();
      });
      invalidate();
    });
    doc.querySelectorAll('[data-pxu-model]').forEach(button => button.addEventListener('click', () => {
      const input = doc.getElementById('pk-xref-input'), run = doc.getElementById('pk-xref-btn');
      if (!input || !run) return;
      input.value=button.dataset.pxuModel; run.click(); input.focus(); input.scrollIntoView({block:'center',behavior:'auto'});
    }));
  }
  const api = {compare, init};
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root.document && !root.PackriftUlineUpgrade) {
    root.PackriftUlineUpgrade=api;
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded',()=>init(root.document)); else init(root.document);
  }
})(typeof window !== 'undefined' ? window : globalThis);
